<template>
  <div class="mt-4">
    <!-- filters -->
    <CompetitionSummaryFilters
      class="mb-4"
      @filtersApplied="loadSummary"
      @refresh="refreshFilters"
      :key="refreshKey"
    />

    <!-- reports -->
    <CompetitionSummary :loading="loading" />
  </div>
</template>

<script>
import CompetitionSummaryFilters from './CompetitionSummaryFilters'
import CompetitionSummary from './CompetitionSummary'
import { createNamespacedHelpers } from 'vuex'

const CompetitionModule = createNamespacedHelpers('competition')

export default {
  name: 'CompetitionSummaryView',
  components: {
    CompetitionSummaryFilters,
    CompetitionSummary
  },
  data: () => ({
    loading: true,
    refreshKey: 0
  }),
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    ...CompetitionModule.mapActions(['fetchBreakdown']),
    async loadSummary() {
      this.loading = true
      await this.fetchBreakdown()
      this.loading = false
    },
    refreshFilters() {
      this.refreshKey += 1
    }
  }
}
</script>
